import React from 'react';
import {Box, Grid} from '@mui/material';
import ArrBarChart from '../../../components/common/arr-bar-chart/ArrBarChart';
import {Link} from 'react-router-dom';

const sampleData = [{label: 'Tag3', value: 4}];

const sampleData1 = [
  {label: 'Tag1', value: 350},
  {label: 'Tag3', value: 229},
  {label: 'Tag2', value: 450},
];

const BarChartDemo: React.FC = () => {
  return (
    <Box>
      <h1>ArrBarChart</h1>

      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />

      <Grid container spacing={2}>
        <Grid size={6}>
          <ArrBarChart
            data={sampleData}
            xLabel="Count of Docs with Each Tag"
            barColor="#6366f1"
            maxVisibleItems={3}
            dataTestId="single-item-bar-chart"
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid size={6}>
          <ArrBarChart
            data={sampleData1}
            xLabel="Count of Docs with Each Tag"
            barColor="#6366f1"
            maxVisibleItems={3}
            dataTestId="multi-item-bar-chart"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BarChartDemo;
